import { LocalStorageKeys } from '../enums/local-storage-keys';

export function setToLocalStorage(key: LocalStorageKeys, data: any) {
  if (typeof window !== 'undefined') {
    localStorage.setItem(key, JSON.stringify(data));
  }
}
